import React from 'react';
import { FiLock } from 'react-icons/fi';
import { openExternalUrl } from '../services/webviewService';

const UnauthenticatedMessage: React.FC = () => {
  return (
    <div className="flex h-full items-center justify-center bg-ds-canvas px-4">
      <div className="max-w-md text-center">
        <div className="mb-6 inline-flex h-20 w-20 items-center justify-center rounded-full bg-ds-subtle">
          <FiLock className="h-10 w-10 text-ds-400" />
        </div>
        <h2 className="mb-4 text-2xl font-bold text-ds-ink">
          احراز هویت لازمه
        </h2>
        <p className="mb-8 text-sm leading-7 text-ds-600">
          برای استفاده از دستیار هوش مصنوعی، لطفاً اول وارد حساب کاربریت شو.
        </p>
        <a
          href="https://basalam.com/accounts/login?prev=https://ai-agent.basalam.com"
          onClick={(e) => {
            e.preventDefault();
            openExternalUrl('https://basalam.com/accounts/login?prev=https://ai-agent.basalam.com');
          }}
          className="inline-flex h-10 items-center rounded-ds-6 bg-ds-primary px-6 text-[13px] font-bold text-white transition-colors hover:bg-ds-primary-strong"
        >
          ورود به حساب کاربری
        </a>
      </div>
    </div>
  );
};

export default UnauthenticatedMessage;
